import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>O'quvchi yaratish</title>
		</Helmet>
	)
}

export default Head
